import { FitTier, FIT_TIER_LABEL, FIT_TIER_DESCRIPTION, FIT_TIER_BADGE_CLASS } from "@/lib/types";

interface Props {
  tier: FitTier;
  size?: "sm" | "md";
}

/**
 * Compact pill for the per-agency Fit Tier of a lead.
 * Distinct from the score pill: this answers "is this lead a good fit for ME?"
 * regardless of how generally hot the lead is.
 */
export default function FitTierBadge({ tier, size = "sm" }: Props) {
  const cls = FIT_TIER_BADGE_CLASS[tier];
  const sizeCls = size === "md" ? "px-2.5 py-1 text-xs" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      title={FIT_TIER_DESCRIPTION[tier]}
      className={`inline-flex items-center rounded-full border font-semibold uppercase tracking-wide ${sizeCls} ${cls}`}
    >
      {FIT_TIER_LABEL[tier]}
    </span>
  );
}